import React, { useState, useEffect } from "react";
import { Table, Dropdown, Spinner, Form } from "react-bootstrap";
import { FaFire } from "react-icons/fa";

const BinanceLiquidations = () => {
  const [liquidations, setLiquidations] = useState([]);
  const [selectedSymbol, setSelectedSymbol] = useState("ALL");
  const [loading, setLoading] = useState(true);
  const [maxRows, setMaxRows] = useState(20);

  useEffect(() => {
    const ws = new WebSocket("wss://fstream.binance.com/ws/!forceOrder@arr");

    ws.onopen = () => {
      console.log("✅ WebSocket 연결 성공");
      setLoading(false);
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);

      if (data && data.o) {
        const order = data.o;
        const newLiquidation = {
          symbol: order.s.replace(/(USDT|BUSD|USDC)$/, "/$1"), // 코인명 변경
          price: parseFloat(order.p),
          quantity: parseFloat(order.q),
          side: order.S === "BUY" ? "Long" : "Short",
          timestamp: new Date(order.T).toLocaleTimeString(),
        };

        setLiquidations((prev) => [newLiquidation, ...prev].slice(0, maxRows));
      }
    };

    ws.onerror = (error) => {
      console.error("WebSocket 오류:", error);
    };

    ws.onclose = () => {
      console.log("WebSocket 연결 종료");
    };

    return () => {
      ws.close();
    };
  }, [maxRows]);

  const filteredLiquidations =
    selectedSymbol === "ALL"
      ? liquidations
      : liquidations.filter((liq) => liq.symbol === selectedSymbol);

  const uniqueSymbols = ["ALL", ...new Set(liquidations.map((liq) => liq.symbol))];

  return (    
    <div className="crypto-card-container py-4" style={{ maxWidth: 600 }}>
      <div className="crypto-card">
        <h5 className="fw-bold text-center mb-3">
          <FaFire className="text-danger me-2 animate-pulse" />
          바이낸스 실시간 롱/숏 청산 원장
        </h5>

        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div className="d-flex align-items-center gap-2">
            <span className="text-secondary small">필터:</span>
            <Dropdown>
              <Dropdown.Toggle variant="outline-primary" size="sm" style={{ borderRadius: '8px' }}>
                {selectedSymbol === "ALL" ? "모든 자산 (ALL)" : selectedSymbol}
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {uniqueSymbols.map((symbol) => (
                  <Dropdown.Item key={symbol} onClick={() => setSelectedSymbol(symbol)}>
                    {symbol === "ALL" ? "모든 자산 (ALL)" : symbol}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="d-flex align-items-center gap-2" style={{ fontSize: '0.85rem' }}>
            <span className="text-secondary">최대 노출:</span>
            <Form.Control
              type="number"
              min="1"
              max="50"
              value={maxRows}
              onChange={(e) => setMaxRows(Number(e.target.value))}
              style={{ width: 70, borderRadius: '6px', padding: '4px 8px' }}
            />
          </div>
        </div>

        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" variant="primary" />
            <p className="text-muted mt-2 small">소켓 연결 진행 중...</p>
          </div>
        ) : filteredLiquidations.length === 0 ? (
          <div className="text-center text-secondary my-4 p-4 border rounded border-dashed" style={{ fontSize: '0.85rem' }}>
            ⏳ 실시간 청산 주문 대기 중...
          </div>
        ) : (
          <div className="crypto-table-wrapper">
            <Table hover size="sm" className="crypto-table">
              <thead>
                <tr>
                  <th>자산</th>
                  <th className="text-end">청산가</th>
                  <th className="text-end">수량</th>
                  <th className="text-center">포지션</th>
                  <th className="text-end">시간</th>
                </tr>
              </thead>
              <tbody>
                {filteredLiquidations.map((liq, index) => (
                  <tr key={index}>
                    <td className="fw-bold text-dark">{liq.symbol}</td>
                    <td className="text-end font-monospace">{liq.price.toLocaleString()} USDT</td>
                    <td className="text-end font-monospace">{liq.quantity.toFixed(4)}</td>
                    <td className="text-center">
                      <span className={liq.side === "Long" ? "crypto-badge-long" : "crypto-badge-short"}>
                        {liq.side.toUpperCase()}
                      </span>
                    </td>
                    <td className="text-end text-muted font-monospace" style={{ fontSize: '0.8rem' }}>{liq.timestamp}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </div>
  );
};

export { BinanceLiquidations };
